import componentsCartItem from "/opt/build/repo/domains/checkout/config/app/components/cart/item"
import componentsCartShippingProgress from "/opt/build/repo/domains/checkout/config/app/components/cart/shippingProgress"
    
export default {"components":{"cart":{"item":componentsCartItem,"shippingProgress":componentsCartShippingProgress}}}
